import { Empty, theme } from "antd";
import { ReactNode } from "react";

/** Small antd table: header row and a one-line body row are both 39px (8px padding + 22px line + border). */
export const TABLE_HEADER_HEIGHT = 39;
export const TABLE_ROW_HEIGHT = 39;
const DEFAULT_VISIBLE_ROWS = 3;
/** The empty placeholder cell's own vertical padding + bottom border. */
const PLACEHOLDER_CHROME = 17;

/**
 * Frame for an event-targeting list (departments / attendees): a bordered card that sets the list apart
 * from the picker above it, ALWAYS sized to the header plus `visibleRows` rows (default three) — empty,
 * partly filled or full — so the dialog never jumps as items are added. Beyond that the list scrolls with
 * a thin scrollbar (the sticky table header stays put).
 */
function TargetListFrame(props: {
  children: ReactNode;
  rowHeight?: number;
  /** 0 for a headerless list. */
  headerHeight?: number;
  visibleRows?: number;
}) {
  const { token } = theme.useToken();
  const rowHeight = props.rowHeight ?? TABLE_ROW_HEIGHT;
  const headerHeight = props.headerHeight ?? TABLE_HEADER_HEIGHT;
  const visibleRows = props.visibleRows ?? DEFAULT_VISIBLE_ROWS;
  return (
    <div
      className="thin-scroll overflow-y-auto overflow-x-hidden rounded-md border border-solid"
      style={{
        height: headerHeight + visibleRows * rowHeight,
        borderColor: token.colorBorderSecondary,
        backgroundColor: token.colorBgContainer,
      }}
    >
      {props.children}
    </div>
  );
}

/** Table `locale.emptyText` that fills the framed body and centers the message in it. */
export function frameEmptyText(
  text: string,
  rowHeight = TABLE_ROW_HEIGHT,
  visibleRows = DEFAULT_VISIBLE_ROWS,
): ReactNode {
  return (
    <div
      className="flex items-center justify-center"
      style={{ height: visibleRows * rowHeight - PLACEHOLDER_CHROME }}
    >
      <Empty
        style={{ margin: 0 }}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={text}
      />
    </div>
  );
}

export default TargetListFrame;
